import {
  ACTION_REGISTRATION_ERROR,
  ACTION_REGISTRATION_LOADED,
  ACTION_REGISTRATION_LOADING
} from '../constants'

const registrationReducer = (state = {
  loading: false,
  error: null,
  message: null
}, {type, payload}) => {
  if (type === ACTION_REGISTRATION_LOADED) {
    return {
      loading: false,
      error: null,
      message: "Registration Successful. Please check your email for activation."
    }
  }

  if (type === ACTION_REGISTRATION_LOADING) {
    return {
      loading: true,
      error: null,
      message: null
    }
  }

  if (type === ACTION_REGISTRATION_ERROR) {
    return {
      loading: false,
      error: op.get(payload, 'xhr.response', payload),
      message: null
    }
  }

  return state
}

export default registrationReducer



// WEBPACK FOOTER //
// ./src/store/registrationReducer.js